/**
 * Family Index [New] — smooth-scroll to family row anchors
 */
(function () {
  var SECTION_TYPE = 'olfactive-family-index-new';

  function prefersReducedMotion() {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function scrollToTarget(id) {
    if (!id) return false;
    var target = document.getElementById(id);
    if (!target) return false;
    target.scrollIntoView({
      behavior: prefersReducedMotion() ? 'auto' : 'smooth',
      block: 'start',
    });
    if (history.replaceState) {
      history.replaceState(null, '', '#' + id);
    }
    return true;
  }

  function enhance(root) {
    if (!root || root._vgOfiReady) return;
    root._vgOfiReady = true;

    root.addEventListener('click', function (event) {
      var link = event.target.closest('a[href^="#"]');
      if (!link || !root.contains(link)) return;
      var href = link.getAttribute('href') || '';
      var id = href.slice(1);
      if (!id) return;
      if (scrollToTarget(id)) {
        event.preventDefault();
      }
    });
  }

  function initAll() {
    document.querySelectorAll('[data-section-type="' + SECTION_TYPE + '"]').forEach(enhance);
  }

  document.addEventListener('DOMContentLoaded', initAll);
  document.addEventListener('shopify:section:load', function (event) {
    var root =
      (event.target.querySelector &&
        event.target.querySelector('[data-section-type="' + SECTION_TYPE + '"]')) ||
      null;
    if (!root && event.target.getAttribute && event.target.getAttribute('data-section-type') === SECTION_TYPE) {
      root = event.target;
    }
    if (root) {
      root._vgOfiReady = false;
      enhance(root);
    }
  });
})();
